"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _radium = _interopRequireDefault(require("radium"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  impactButton: {
    width: '100%',
    height: '60px',
    WebkitAppearance: 'button',
    position: 'relative',
    display: 'inline-block',
    fontSize: '1.28571rem',
    letterSpacing: '.02rem',
    backgroundColor: '#0093d3',
    padding: '12px 46px',
    borderRadius: '2px',
    color: '#fff',
    overflow: 'hidden',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    transform: 'translateZ(0)',
    textDecoration: 'none',
    border: 0,
    cursor: 'pointer',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: 1.15,
    margin: 0,
    boxSizing: 'border-box',
    ':hover': {
      backgroundColor: '#20ace9',
      boxShadow: '0 1px 1px 0 rgba(0,0,0,.14), 0 1px 7px 0 rgba(0,0,0,.12), 0 1px 1px -1px rgba(0,0,0,.2)'
    }
  }
};

var ImpactButton = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(ImpactButton, _React$PureComponent);

  var _super = _createSuper(ImpactButton);

  function ImpactButton() {
    var _this;

    (0, _classCallCheck2.default)(this, ImpactButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleClick = function (ev) {
      ev.preventDefault();

      _this.props.onClick(ev);
    };

    return _this;
  }

  (0, _createClass2.default)(ImpactButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$defaultLa = _this$props.defaultLabel,
          defaultLabel = _this$props$defaultLa === void 0 ? 'Button' : _this$props$defaultLa,
          data_selector = _this$props.data_selector;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
        "data-selector": data_selector,
        type: "button",
        style: styles.impactButton,
        onClick: this.handleClick
      }, defaultLabel));
    }
  }]);
  return ImpactButton;
}(_react.default.PureComponent);

ImpactButton.propTypes = {
  defaultLabel: _propTypes.default.string,
  onClick: _propTypes.default.func,
  data_selector: _propTypes.default.string
};

var _default = (0, _radium.default)(ImpactButton);

exports.default = _default;